module.exports = __webpack_public_path__ + "img/brainfit_4.b5723b4d.jpg";